<template>
<div class="chapter">
<div class="inner_page">
<p class="western2" id="calibre_pb_2">A <span class="c"><a href="http://www.permutedpress.com/" target="_blank">PERMUTED PRESS</a></span> book</p>
<p class="western3">published at Smashwords.</p>
<p class="western3"> <br class="calibre3"/></p>
<p class="western3">ISBN (trade paperback): 978-1-61868-106-5</p>
<p class="western3">ISBN (eBook): 978-1-61868-107-2</p>
<p class="western3"> <br class="calibre3"/></p>
<p class="western3"><i class="calibre4">Blood Soaked and Contagious</i> copyright
© 2011, 2013</p>
<p class="western3">by James Crawford.</p>
<p class="western3">All Rights Reserved.</p>
<p class="western3">Cover design by Karen Fletcher</p>
<p class="western3"> <br class="calibre3"/></p>
<p class="western5">This book is a work of fiction. People,
places, events, and situations are the product of the author’s
imagination. Any resemblance to actual persons, living or dead, or
historical events, is purely coincidental.</p>
<p class="western3"> <br class="calibre3"/></p>
<p class="western5">No part of this book may be reproduced,
stored in a retrieval system, or transmitted by any means without
the written permission of the author and publisher.</p>
<p class="western3"> <br class="calibre3"/></p>
<p class="western5">Version 3.30.13.1.</p>
<p class="western3"> <br class="calibre3"/></p>
<p class="western3"> <br class="calibre3"/></p>
<p class="western3"> <br class="calibre3"/></p>
<p class="western3"><img alt="tmp_f099aff482e799492a35054ee1867e1f_WrMliK_html_1467a33.png" class="calibre5" id="Picture_4" src="tmp_f099aff482e799492a35054ee1867e1f_WrMliK_html_1467a33.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_f099aff482e799492a35054ee1867e1f_WrMliK.ch.fixed.fc.tidied.stylehacked.xfixed_split_003.vue?1d89892f